module.exports = __webpack_public_path__ + "img/6.fb3e05e8.svg";